import { CButton, CCol, CLabel, CRow, CTextarea } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { apiCallSP, apiCallSPPost, apiCallSPPut } from "src/_apiConfig/apiCall";
import ToastMessage from "src/_components/ToastMessage";
import {
  AlertResponse,
  addToastError,
  addToastSuccess,
} from "src/_constants/alert.type";
import Auth from "src/auth";
import {
  CommanPageLoader,
  ControlTextAreaValidationText,
  DetailLabelBind,
  DetailRowOnly,
  DetailSectionBind,
  ViewDocumentButton,
  requiredValid,
} from "src/views/common/Common";
import CustomeModalPopup from "src/views/common/CustomeModalPopup";

const AdHocPaymentView = () => {
  const { authenticated } = Auth();
  //const userId = authenticated.userId;
  const [toasts, setToasts] = useState(AlertResponse);
  const [usersData, setUserData] = useState();
  const [pData, setPData] = useState();
  const [loading, setloading] = useState(false);

  let { AdHocPaymentId } = useParams();
  const decrypted = window.atob(AdHocPaymentId);

  let history = useHistory();

  //Confirmation popup------------------------------------
  const [CPopUpStatusId, setCPopUpStatusId] = useState(0);
  //const [CPopUpId, setCPopUpId] = useState();

  const [showModal, setShowModal] = useState(false);
  const [checkerComment, setCheckerComment] = useState("");
  // adding button loader
  const [ButtonLoader, SetButtonLodaer] = useState(false);
  useEffect(() => {
    setloading(true);
    getData(authenticated.userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const getData = async () => {
    const user_Type =
      authenticated.role === "CGMF" ? 1 : authenticated.role === "DFO" ? 2 : 0;

    if (authenticated) {
      setloading(true);
      setUserData();
      await apiCallSP(
        `LotAdHocPayment/ViewByAdHocPaymentId?AdHocPaymentId=${decrypted}&User_type=${user_Type}&User_id=${authenticated.userId}`
      ).then((res) => {
        if (res.success) {
          setUserData(res.data);
          console.log(res.data);
          const getData = res.data;
          getDataPurchaser(
            getData.collectionSeason,
            getData.tenderId,
            getData.lotId
          );
        } else {
          setloading(false);
        }
      });
    }
  };
  const getDataPurchaser = async (collectionSeason, tenderId, lotId) => {
    if (authenticated) {
      setloading(true);
      setPData();
      if (
        Number(collectionSeason) > 0 &&
        Number(tenderId) > 0 &&
        Number(lotId) > 0
      ) {
        const data = JSON.stringify({
          tender_id: Number(tenderId),
          lot_id: Number(lotId),
          collection_season: Number(collectionSeason),
        });
        await apiCallSPPost("LotAdHocPayment/BidderDetailByLotId", data, [])
          .then((res) => {
            if (res.success && res.totalRecord > 0) {
              //alert("callllll");
              setPData(res.data);
            }
          })
          .finally(() => {
            setloading(false);
          });
      } else {
        setPData();
        setloading(false);
      }
    }
  };

  const BidderDetails = (
    <>
      <DetailLabelBind
        lable="Email Address"
        value={pData?.emailId && pData?.emailId}
      />
      <DetailLabelBind
        lable="Goods and Services"
        value={pData?.gst && pData?.gst}
      />
      <DetailLabelBind
        lable="Propritor Name"
        value={pData?.username && pData?.username}
      />
      <DetailLabelBind
        lable="Company Name"
        value={pData?.companyName && pData?.companyName}
      />
      <DetailLabelBind lable="Mobile" value={pData?.mobile && pData?.mobile} />
      <DetailLabelBind
        lable="Name of Forest Division Where Tenderer Registered"
        value={pData?.registeredDistrict && pData?.registeredDistrict}
      />
    </>
  );
  const valueSet = (data) => {
    return data && data;
  };

  const getPaymentTypeValue = (id) => {
    switch (id) {
      case 1:
        return "Payment Collected without GST";
      case 2:
        return "Payment Collected with GST";
      case 3:
        return "Only Collected GST";
      default:
        return "";
    }
  };
  const getStatusValue = (id) => {
    switch (id) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Reject";
      case 4:
        return "Clarification";
      default:
        return "";
    }
  };

  const AdminResponse = (statusid) => {
    setCPopUpStatusId(statusid);
    //setCPopUpId(1);
    setShowModal(true);
  };

  const handleClose = (event, reason) => {
    console.log("reason : ", reason);
    if (reason === "escapeKeyDown") {
      console.log("ddd", "escapeKeyDown");
    }
    if (reason === "backdropClick") {
      console.log("ddd", "backdropClick");
    }
    if (reason !== "backdropClick") {
      hideModal();
    }
  };
  const hideModal = () => setShowModal(false);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const SubmitConfirmationPopUpResponse = async (e) => {
    e.preventDefault(); // Prevent default form submission
    //ApproveApiCall(CPopUpId);
    SetButtonLodaer(true);
    if (CPopUpStatusId === 4) {
      const usertype =
        authenticated.role === "CGMF"
          ? "1"
          : authenticated.role === "DFO"
          ? "2"
          : "0";

      if (checkerComment.length > 0) {
        const data = JSON.stringify({
          id: decrypted,
          inserted_by: authenticated.userId,
          user_type: usertype,
          comment: checkerComment,
          lot_id: usersData.lotId,
        });
        await apiCallSPPut("LotAdHocPayment/Clarification/Insert", data, 0)
          .then(async (res) => {
            if (res.success) {
              console.log("handleSubmit : ", res);
              addToastSuccess(setToasts, res.message, 2500);
              setCheckerComment("");

              hideModal();

              console.log("Process resumed after 5 seconds!");
              await delay(1000); // Wait for 5 seconds
              getData();
              //handleConfirmationPopUpModalClose();
            } else {
              if (res.message !== "") {
                console.log(res.errors);
                console.log(res.errors.Comment[0]);
                addToastError(setToasts, res.errors.Comment[0], 0);
              }
              setCheckerComment("");
              //hideModal();
            }
          })
          .finally(() => {
            SetButtonLodaer(false);
          });
      } else {
        let FromStateJson = formState["checkerComment"];
        FromStateJson.valid = false;
        FromStateJson.errors = "Please enter a Comment";
        setFromState((prevState) => ({
          ...prevState,
          [e.target.name]: FromStateJson,
        }));
      }
    } else if (CPopUpStatusId === 2 || CPopUpStatusId === 3) {
      if (checkerComment.length > 0) {
        const data = JSON.stringify({
          id: decrypted,
          inserted_by: authenticated.userId,
          status: CPopUpStatusId,
          comment: checkerComment,
          lot_id: usersData.lotId,
        });
        await apiCallSPPut("LotAdHocPayment/Checker/StatusUpdate", data, 0)
          .then(async (res) => {
            if (res.success) {
              console.log("handleSubmit : ", res);
              addToastSuccess(setToasts, res.message);
              setCheckerComment("");

              hideModal();
              //handleConfirmationPopUpModalClose();
            } else {
              addToastError(setToasts, res.message, 0);
              setCheckerComment("");
              hideModal();
            }
          })
          .finally(() => {
            getData();
            SetButtonLodaer(false);
          });
      } else {
        let FromStateJson = formState["checkerComment"];
        FromStateJson.valid = false;
        FromStateJson.errors = "Please enter a Comment";
        setFromState((prevState) => ({
          ...prevState,
          [e.target.name]: FromStateJson,
        }));
      }
    }
  };

  const totalAmount = () => {
    const Value =
      usersData?.amount +
      usersData?.cgstAmount +
      usersData?.sgstAmount +
      usersData?.igstAmount;
    console.log(
      "igstAmount  : ",
      usersData?.igstAmount,
      " | ",
      Value.toFixed(2)
    );
    return Value.toFixed(2);
  };

  const [formState, setFromState] = useState({
    checkerComment: { errors: "", valid: true },
  });
  const handleChangesComment = (e) => {
    setCheckerComment(e.target.value);
    const msg = getCommentValidationErrors(e);
    console.log(msg);
    let validResp = "";
    if (msg.length > 0) {
      validResp = requiredValid(false, msg[0]);
    } else {
      validResp = requiredValid(true, "");
    }

    if (!validResp.isValid) {
      e.target.focus();
    }
    let FromStateJson = formState[e.target.name];
    FromStateJson.valid = validResp.isValid;
    FromStateJson.errors = validResp.Message;
    setFromState((prevState) => ({
      ...prevState,
      [e.target.name]: FromStateJson,
    }));
  };

  const getCommentValidationErrors = (e) => {
    debugger;
    const getValue = e.target.value;
    const errors = [];

    if (!getValue && getValue.length === 0) {
      errors.push("Please enter a Comment");
    }
    if (getValue.length > 300) {
      errors.push("Comment Maximum 300 Characters allowed.");
    }
    return errors;
  };
  return (
    <div>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      {loading ? (
        <CommanPageLoader title={"Adjustment Payment - View"} />
      ) : (
        <>
          {usersData && (
            <div className="view">
              <DetailSectionBind
                header={"Adjustment Payment - View"}
                className={"mb-2"}
              />

              <DetailSectionBind
                className={"mb-2"}
                title={"Lot Detail"}
                body={
                  <>
                    <DetailLabelBind
                      lable="Collection Season"
                      value={valueSet(usersData?.collectionSeason)}
                    />
                    <DetailLabelBind
                      lable="Tender No."
                      value={valueSet(usersData?.tenderNo)}
                    />
                    <DetailLabelBind
                      lable="Lot No."
                      value={valueSet(usersData?.lotNo)}
                    />
                    {/* <DetailLabelBind
                      lable="Purchaser Name"
                      value={valueSet(usersData?.purchaserName)}
                    /> */}
                  </>
                }
              />
              <DetailSectionBind
                className={"mt-1"}
                title={"Bidder Detail"}
                body={<>{BidderDetails}</>}
              />

              <DetailSectionBind
                className={"mb-2"}
                title={"Details"}
                body={
                  <>
                    {" "}
                    <DetailLabelBind
                      className="mt-2 col-xxl-6 col-xl-6 col-md-6 col-sm-6 col-xs-12"
                      lable="Title/Purpose"
                      value={valueSet(usersData?.title_Purpose)}
                    />
                    <DetailLabelBind
                      className="mt-2 col-xxl-6 col-xl-6 col-md-6 col-sm-6 col-xs-12"
                      lable="DFO Comment"
                      value={valueSet(usersData?.insertedComment)}
                    />
                    <DetailLabelBind
                      lable="DFO Created Date"
                      value={valueSet(usersData?.insertedDateTime)}
                    />
                    <DetailLabelBind
                      lable="DFO Name"
                      value={valueSet(usersData?.insertByName)}
                    />
                    <DetailLabelBind
                      lable="Payment Type"
                      value={getPaymentTypeValue(
                        valueSet(usersData?.paymentTypeId)
                      )}
                    />
                    <DetailLabelBind
                      lable="Status"
                      value={getStatusValue(valueSet(usersData?.status))}
                    />
                    <DetailLabelBind
                      lable="Amount"
                      value={valueSet(usersData?.amount)}
                    />
                    <DetailLabelBind
                      lable="CGST Amount"
                      value={valueSet(usersData?.cgstAmount)}
                    />
                    <DetailLabelBind
                      lable="SGST Amount"
                      value={valueSet(usersData?.sgstAmount)}
                    />
                    <DetailLabelBind
                      lable="IGST Amount"
                      value={valueSet(usersData?.igstAmount)}
                    />
                    <DetailLabelBind
                      lable="Total Amount"
                      value={totalAmount()}
                    />
                    <DetailLabelBind
                      lable="Due Date"
                      value={valueSet(usersData?.dueDate)}
                    />
                    <ViewDocumentButton
                      label={"Supporting Document"}
                      filepath={`Documents/AdHocPayment/${usersData.lotId}`}
                      fileName={valueSet(usersData?.supportFilePath)}
                    />
                    {usersData?.makerClarificationComment !== null && (
                      <>
                        <DetailLabelBind
                          lable="DFO Clarification Date"
                          value={valueSet(usersData?.makerClarificationDate)}
                        />
                        {/* col-xxl-12 col-xl-12 col-md-12 col-sm-12 col-xs-12 */}
                        <DetailLabelBind
                          className="mt-2 col-xxl-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 "
                          lable="DFO Clarification Comment"
                          value={valueSet(usersData?.makerClarificationComment)}
                        />
                      </>
                    )}
                    {usersData?.checkerBy > 0 && (
                      <>
                        <DetailLabelBind
                          lable={
                            usersData?.status === 4
                              ? "Admin Clarification Date"
                              : "Admin Date"
                          }
                          value={valueSet(usersData?.checkerDate)}
                        />
                        <DetailLabelBind
                          lable={"Admin Name"}
                          // {
                          //   usersData?.status === 4
                          //     ? "Checker Clarification Name"
                          //     : "Checker Name"
                          // }
                          value={valueSet(usersData?.checkerByName)}
                        />
                        {/* col-xxl-12 col-xl-12 col-md-12 col-sm-12 col-xs-12 */}
                        <DetailLabelBind
                          className="mt-2 col-xxl-9 col-xl-9 col-md-9 col-sm-12 col-xs-12"
                          lable={
                            usersData?.status === 4
                              ? "Admin Clarification Comment"
                              : "Admin Comment"
                          }
                          value={valueSet(usersData?.checkerComment)}
                        />
                      </>
                    )}
                  </>
                }
              />

              <div className="row">
                <div
                  className={
                    "ml-3 mt-2 mb-2 col-xl-6 col-sm-5 col-xs-12 col-12"
                  }
                >
                  {authenticated.role === "CGMF" &&
                  (usersData?.status === 0 ||
                    usersData?.status === 1 ||
                    (usersData?.status === 4 &&
                      usersData?.isClarificationByLoginUser)) ? (
                    <>
                      <CButton
                        className=""
                        color="success"
                        type="button"
                        onClick={() => {
                          AdminResponse(2);
                        }}
                      >
                        Approve
                      </CButton>
                      <CButton
                        className="ml-2 mr-2 ml-3"
                        color="danger"
                        type="button"
                        onClick={() => {
                          AdminResponse(3);
                        }}
                      >
                        Reject
                      </CButton>
                    </>
                  ) : (
                    ""
                  )}

                  {authenticated.role === "CGMF" &&
                  (usersData?.status === 0 ||
                    usersData?.status === 1 ||
                    (usersData?.status === 4 &&
                      usersData?.isClarificationByLoginUser)) ? (
                    <CButton
                      className="ml-2 mr-2 ml-3"
                      color="info"
                      type="button"
                      onClick={() => {
                        AdminResponse(4);
                      }}
                    >
                      Clarification
                    </CButton>
                  ) : (
                    ""
                  )}
                  {/* {authenticated.role === "DFO" &&
                  usersData?.status === 4 &&
                  usersData?.isClarificationByLoginUser ? (
                    <CButton
                      className="ml-2 mr-2"
                      color="info"
                      type="button"
                      onClick={() => {
                        AdminResponse(4);
                      }}
                    >
                      Clarification
                    </CButton>
                  ) : (
                    ""
                  )} */}
                  <CButton
                    type="button"
                    className="ml-3"
                    color="dark"
                    onClick={() => history.goBack()}
                  >
                    Go Back
                  </CButton>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <CustomeModalPopup
        onOpen={showModal}
        onClose={handleClose}
        onSubmitButton={SubmitConfirmationPopUpResponse}
        onCloseButton={handleClose}
        isSubmitBtnDisabled={ButtonLoader}
        isFromSubmit={true}
        popupWith={520}
        btnCColstyle={{ textAlign: "right" }}
        body={
          <>
            <DetailRowOnly
              body={
                <>
                  Adjustment Payment -{CPopUpStatusId === 2 && "Approve"}
                  {CPopUpStatusId === 3 && "Reject"}
                  {CPopUpStatusId === 4 && "Clarification"}
                </>
              }
            />
            <hr />
            <CRow className="mb-3">
              <ControlTextAreaValidationText
                label="Comment"
                isRequired={true}
                id="checkerComment"
                name="checkerComment"
                rows="2"
                value={checkerComment}
                onChange={(e) => handleChangesComment(e)}
                invalid={checkerComment === "" ? true : false}
                min={0}
                max={300}
                errorMessage={formState.checkerComment.errors}
              />
            </CRow>
          </>
        }
      />
    </div>
  );
};

export default AdHocPaymentView;
